module.exports = __webpack_public_path__ + "static/img/m301.fa33e091.gif";